var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterlingua(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 680,
    height: 432,
    viewBox: "0 0 340 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h340v216H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00f",
    d: "M0 0h340v108H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m150.7 126.3-25.6-3.1c-14.1-1.7-47.5-5.7-74.3-8.9-26.9-3.2-48.8-6-48.8-6.3 0-.3 21.9-3.1 48.8-6.3 26.8-3.2 60.2-7.2 74.3-8.9l25.6-3.1 9.4-43.8C165.3 21.7 169.7 2 170 2c.3 0 4.7 19.7 9.9 43.9l9.4 43.8 25.6 3.1c14.1 1.7 47.5 5.7 74.3 8.9 26.9 3.2 48.8 6 48.8 6.3 0 .3-21.9 3.1-48.8 6.3-26.8 3.2-60.2 7.2-74.3 8.9l-25.6 3.1-9.4 43.8c-5.2 24.2-9.6 43.9-9.9 43.9-.3 0-4.7-19.7-9.9-43.9Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlingua);
export default __webpack_public_path__ + "static/media/interlingua.b4c3712f3dfc9ae8beee63e977ce1c98.svg";
export { ForwardRef as ReactComponent };